
export const styledMessagesView = {
    display: 'flex',
    flexDirection: 'column',
    variants: {transcript: {true: {'& time': {userSelect: 'none'}}}},
}
